import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { UserCircle } from "lucide-react";
import PageHeader from "../../components/PageHeader";
import { getArchitectProfile, updateArchitectProfile } from "../../services/architect";

function Row({ label, value }) {
  return (
    <div className="flex justify-between border-b py-2 text-sm">
      <span className="text-gray-500">{label}</span>
      <span className="font-medium text-gray-800">{value || "—"}</span>
    </div>
  );
}

function ArchitectProfile() {
  const [p, setP] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getArchitectProfile().then((data) => {
      setP(data);
      setCompanyName(data?.companyName || "");
      setGstNumber(data?.gstNumber || "");
    });
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const updated = await updateArchitectProfile({ companyName, gstNumber });
      setP(updated);
      toast.success("Profile updated.");
    } catch (e) {
      toast.error(e?.detail || e?.response?.data?.detail || "Update failed.");
    } finally {
      setSaving(false);
    }
  };

  if (!p) return <div className="p-6 text-gray-400">Loading…</div>;

  return (
    <div className="p-6 space-y-6">
      <PageHeader title="My Profile" subtitle="Architect account" icon={UserCircle} />
      <div className="max-w-xl rounded-lg border border-gray-200 bg-white p-6">
        <Row label="Name" value={p.name} />
        <Row label="Email" value={p.email} />
        <Row label="Mobile" value={p.mobile} />
        <div className="mt-4 space-y-3">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Company Name</label>
            <input
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-flamingo-300"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">GST Number</label>
            <input
              value={gstNumber}
              onChange={(e) => setGstNumber(e.target.value)}
              className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-flamingo-300"
            />
          </div>
          <button
            onClick={save}
            disabled={saving}
            className="rounded-md bg-flamingo-600 px-4 py-2 text-sm font-semibold text-white hover:bg-flamingo-700 disabled:opacity-50"
          >
            {saving ? "Saving…" : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ArchitectProfile;
